import * as _ from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IArrayResponse } from '@nkr/store/index';
import { IInvoiceSummary, IInvoicePayment, ActionsAdminInvoice } from '@nkr/store/billing/actions-admin-invoice';
import DateTimePicker from '@nkr/components/date-time-picker';
import GridInvoiceCollectionsDetailAdd from "./grid-collections-detail-add";
import { IBaseResponse } from '@nkr/models/index';
import MyDTPicker from '@nkr/components/date-time-picker-with-close-button';
import DateTime from 'react-datetime';
import { toast } from "react-toastify";

interface IProps {
    data        : IInvoiceSummary,
    updateRow   : ( invoiceId : number, paymentSum : number ) => void
}

interface IStateProps {

}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPayments: (invoiceId: number) => Promise<IArrayResponse<IInvoicePayment>>,
    removePayment: (payment: IInvoicePayment) => Promise<IBaseResponse>,
    updateStopNotices: (invoice: IInvoiceSummary) => Promise<IBaseResponse>
}

interface IState {
    invoice: IInvoiceSummary,
    payments: IInvoicePayment[]
}

type TProps = IProps & IStateProps & IDispatchProps;

class GridInvoiceCollectionsDetail extends React.Component<TProps, IState> {
    readonly state: IState = {
        invoice: {} as IInvoiceSummary,
        payments: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = ( forceRefresh=false ) => {
        if( this.props.data?.id > 0 && (this.state.payments.length == 0 || forceRefresh) ) {
            this.setState({
                invoice : this.props.data
            });

            this.props.showLoading('Getting payments, one moment please...').then(() => {
                this.props.getPayments(this.props.data.id)
                    .then((response: IArrayResponse<IInvoicePayment>) => {
                        if (response.data.success) {
                            this.setState({
                                payments: response.data.results
                            });
                        }
                        let invoiceCopy                     = Object.assign({}, this.state.invoice);
                        let sum = 0;
                        this.state.payments.forEach( item => sum += item.amount );
                        this.props.updateRow( this.props.data.id, sum );
                    })
                    .finally(() => this.props.hideLoading())
            });
        }
    }

    updateDetails = () => {
        this.getData(true);
    }

    handleStopNoticesChange = (e) => {
        let invoiceCopy                     = Object.assign({}, this.state.invoice);
        invoiceCopy.stopLateNoticesUntil    = e?.target?.value || null;

        this.handleStopNoticeSave( invoiceCopy );
    }

    handleStopNoticeSave = ( invoiceData ) => {
        this.props.showLoading('Updating Stop Notices...')
            .then(() => {
                this.props.updateStopNotices( invoiceData )
                    .then((response: any) => {
                        if (response?.data?.success) {
                            toast.success("Stop Notices Updated");
                            this.setState( { invoice : invoiceData } );
                        }
                        else {
                            toast.error("Stop Notice Save Failed");
                        }
                    });
            })
            .finally(() => this.props.hideLoading());
    }

    deletePayment = ( payment  : IInvoicePayment ) => {
        this.props.showLoading('Updating Payments...')
            .then(() => {
                 this.props.removePayment( payment )
                     .then(() => this.updateDetails() );
            })
            .finally(() => this.props.hideLoading());
    }

    getStopNoticeValue = ( selectedValue ) => {
        var hasValue    = selectedValue?.length > 0;
        var returnValue = hasValue ? moment(selectedValue)?.format("YYYY-MM-DD") : "";
        return returnValue;
    }

    render = () => {
        return (
            <div className='row' style={{marginTop:"20px",width:"100%",minHeight:"100%",overflow:"visible"}}>
                <div className='col-xs-12 col-sm-4 col-md-3 col-lg-2'>
                    <div className="panel panel-default" style={{paddingTop:10}}>
                        
                        <div className='form-group'>
                            <label className='col-xs-12 '>Stop Late Notices Until</label>
                            <div className='col-xs-12'>
                                <input className="form-control" type="date"
                                    value={this.getStopNoticeValue(this.state.invoice?.stopLateNoticesUntil)}
                                    onChange={this.handleStopNoticesChange.bind(this)}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-xs-12 col-sm-8 col-md-9 col-lg-10'>

                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Check#</th>
                                <th>Recorded On</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.payments.map( item =>
                            <tr>
                                <td>{moment(item.paymentDate).format("MM/DD/YYYY")}</td>
                                <td>{item.paymentType}</td>
                                <td>${item.amount.toLocaleString(undefined, {maximumFractionDigits:2})}</td>
                                <td>{item.checkNumber}</td>
                                <td>{moment(item.recordedDateTime).format("MM/DD/YYYY")}</td>
                                <td><button className='btn btn-danger' onClick={() => this.deletePayment(item)}>delete</button></td>
                            </tr>
                        )}
                        </tbody>
                        <GridInvoiceCollectionsDetailAdd invoiceId={this.state.invoice.id} onChange={this.updateDetails.bind(this)} />
                    </table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getPayments: (invoiceId) => { return dispatch(ActionsAdminInvoice.getPayments(invoiceId)); },
        removePayment: (payment) => { return dispatch(ActionsAdminInvoice.removePayment(payment)); },
        updateStopNotices: (invoice) => { return dispatch(ActionsAdminInvoice.stopNotices(invoice)) }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(GridInvoiceCollectionsDetail);